/**
 * Axtarış mətninin sadələşdirilməsi.
 *
 * Çox adamın klaviaturasında Azərbaycan hərfləri yoxdur və ya yazmağa
 * əziyyət edir: "cenubi", "turkiye", "isvecre" yazırlar. Həmin hərfləri
 * latın qarşılığına çevirmək bu yazılışların da tapılmasını təmin edir.
 *
 * Eyni funksiya həm saytın öz axtarışında, həm müraciət formasında, həm də
 * xarici saytlara verilən widget-də işlədilir — üçü eyni cür davransın deyə.
 */

/* Ə hərfi kiçildiləndə "ə" olur, ona görə cədvəldə yalnız kiçik hərflər var. */
const FOLD = {
  ə: 'e',
  ı: 'i',
  ö: 'o',
  ü: 'u',
  ç: 'c',
  ş: 's',
  ğ: 'g',
};

/**
 * Mətni kiçik hərfə salır və Azərbaycan hərflərini latınlaşdırır.
 *
 * `toLocaleLowerCase('az')` vacibdir: standart kiçiltmə "İ" hərfini "i̇"
 * (nöqtəli i) edir və "İtaliya" sorğusu heç nə tapmır.
 *
 * @param {string} value Mətn.
 * @returns {string} Müqayisəyə hazır mətn.
 */
const normalizeSearchText = (value) => {
  const lower = String(value ?? '').toLocaleLowerCase('az').trim();
  let folded = '';

  for (let index = 0; index < lower.length; index += 1) {
    folded += FOLD[lower[index]] || lower[index];
  }

  return folded;
};

export default normalizeSearchText;
